module.exports = __webpack_public_path__ + "static/media/rober8.b9050fa5.jpg";